import { render, staticRenderFns } from "./ProductIntroduce.vue?vue&type=template&id=2a6245d5&scoped=true"
import script from "./ProductIntroduce.vue?vue&type=script&lang=js"
export * from "./ProductIntroduce.vue?vue&type=script&lang=js"
import style0 from "./ProductIntroduce.vue?vue&type=style&index=0&id=2a6245d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6245d5",
  null
  
)

export default component.exports